import { styled } from 'baseui'
import { pulseSelectedSurface, reducedMotion } from '../styled-components'
import type { PillBox } from '../useSlidingPill'

export const PulsePillWrapper = styled('div', { position: 'relative' })

export const PulsePill = styled<'div', { $box: PillBox; $animated: boolean; $disabled: boolean }>(
  'div',
  ({ $theme, $box, $animated, $disabled }) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    width: `${$box.width}px`,
    height: `${$box.height}px`,
    transform: `translate(${$box.left}px, ${$box.top}px)`,
    pointerEvents: 'none',
    borderTopLeftRadius: '6px',
    borderTopRightRadius: '6px',
    borderBottomLeftRadius: '6px',
    borderBottomRightRadius: '6px',
    ...pulseSelectedSurface($theme, $disabled),
    transitionProperty: $animated && !$disabled ? 'transform, width, height' : 'none',
    transitionDuration: '150ms',
    transitionTimingFunction: 'ease',
    ...reducedMotion,
  }),
)
